import {
  FeedItemDto,
  UserMemberStatusDto,
} from '@act/shared/data-transfer-objects';
import { EntityState } from '@reduxjs/toolkit';
import { LoadingStatus } from './shared-types';

export type EntityType = 'call' | 'message' | 'note' | 'visit';

export const feedFilterStrings = [
  'call',
  'message',
  'visit',
  'note',
  'task',
  'hospital events',
] as const;

export type FeedFilter = (typeof feedFilterStrings)[number];
export const feedFiltersToEndpointFilters = (feedFilters: FeedFilter[]) => {
  const newFilters: string[] = [...feedFilters];

  if (feedFilters.includes('hospital events')) {
    const hospitalEventsIndex = newFilters.indexOf('hospital events');
    newFilters.push('hospitalization');
    newFilters.splice(hospitalEventsIndex, 1);
  }

  // Handle 'task' filter by expanding it to its component types
  if (feedFilters.includes('task')) {
    const taskIndex = newFilters.indexOf('task');
    newFilters.splice(taskIndex, 1); // Remove 'task'
    newFilters.push(
      'member_status_change_request',
      'member_transfer_request',
      'assigned_workflow_phase'
    );
  }

  return newFilters;
};

export type FeedEntry = EntityState<FeedItemDto, number>;
export type UserMemberStatusesEntry = EntityState<UserMemberStatusDto, number>;

export interface FeedState {
  status: LoadingStatus;
  selectedMemberId: string; // Used for deduplication during loading
  displayedMemberId: string | null; // Used for websocket event filtering
  selectedFeedFilters: FeedFilter[];
  feedItems: FeedEntry;
  userMemberStatuses: UserMemberStatusesEntry;
  lastLoadedPendingItemsMemberId: string | null;
}
